module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logoTitle":"Go to main page"},"ru":{"logoTitle":"Перейти на главную страницу"}}')
  delete Component.options._Ctor
}
